<template>
  <button
    class="text-button"
    :class="[`color-type-${colorType}`, buttonClass]"
    :disabled="disabled"
    :style="buttonStyle"
    @click="handleClick"
  >
    <div class="text-button-content">
      <vs-icon
        v-if="icon"
        :icon="icon"
        :icon-pack="iconPack"
        :size="iconSize"
        class="text-button-icon"
      />
      <span v-if="label" class="text-button-label">{{ label }}</span>
    </div>
  </button>
</template>

<script>
export default {
  name: "TextButton",
  props: {
    /**
     * アイコン名
     * @type {String}
     * @optional
     */
    icon: {
      type: String,
      default: "",
    },
    /**
     * アイコンパック
     * @type {String}
     * @default "feather"
     */
    iconPack: {
      type: String,
      default: "feather",
    },
    /**
     * アイコンサイズ
     * @type {String}
     * @default "18px"
     */
    iconSize: {
      type: String,
      default: "18px",
    },
    /**
     * ラベルテキスト
     * @type {String}
     * @optional
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * ボタンのカラータイプ（normal, secondary）
     * @type {String}
     * @default "normal"
     */
    colorType: {
      type: String,
      default: "normal",
    },
    /**
     * 無効化されているかどうか
     * @type {Boolean}
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * ボタンのスタイル
     * @type {Object|String}
     * @optional
     */
    buttonStyle: {
      type: [Object, String],
      default: () => ({}),
    },
    /**
     * ボタンのクラス
     * @type {String}
     * @optional
     */
    buttonClass: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClick(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.text-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .text-button-content {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .text-button-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .text-button-label {
    white-space: nowrap;
  }

  // normal color type（プライマリカラー：青）
  &.color-type-normal {
    color: $aisea-blue;

    &:hover:not(:disabled) {
      color: darken($aisea-blue, 10%);
      text-decoration: underline;
    }
  }

  // secondary color type（サブカラー：黒）
  &.color-type-secondary {
    color: $aisea-black;

    &:hover:not(:disabled) {
      color: darken($aisea-black, 10%);
      text-decoration: underline;
    }
  }
}
</style>
